import { css } from "emotion";
import CMSComponent from "../../../components/CMSComponent";
import H2 from "../../../components/global/H2";
import P from "../../../components/global/P";
import Banner from "../../../components/layout/Banner";
import Layout from "../../../components/layout/Layout";
import { updateTitle } from "../../../utils/BrowserUtils";
import DescriptionBlock from "../DescriptionBlock";
import Flag from "./componets/Flag";
import HowToHelp from "./componets/HowToHelp";
import HowWeDeliver from "./componets/HowWeDeliver";
import OurImpacts from "./componets/OurImpacts";
import ProjectDeliveryPartners from "./componets/ProjectDeliveryPartners";
import Quote from "./componets/Quote";

const bannerImage = require("../../../assets/Projects/manaiakalaniBanner.png");

const icTechForKids = require("../../../assets/Projects/ic_tech_for_kids.svg");
const icRetoolingSchools = require("../../../assets/Projects/ic_retooling_schools.svg");

const quoteImage = require("../../../assets/Projects/pat_snedden.png");
const manaiakalaniDesc = require("../../../assets/Projects/Manaiakalani.png");
const partnerLogo = require("../../../assets/Projects/manaiakalaniLogo.png");

const bannerContent = css({
  padding: "0px 0px 0px 80px",
  textAlign: "left",
  h2: {
    maxWidth: 402,
    marginBottom: 16,
    fontSize: 36
  },
  p: {
    maxWidth: 402,
    marginBottom: 20,
    marginLeft: 0,
    fontSize: 18
  },
  "@media(max-width: 1080px)": {
    padding: "112px 0px 24px 80px"
  },
  "@media(max-width: 768px)": {
    padding: "40px 14px 24px 14px",
    h2: {
      fontSize: 22
    },
    p: {
      fontSize: 16
    }
  }
});

const impactsObj = [
  {
    title: "Every ticket counts",
    content: "$250 = 1 year",
    subtext: "access to laptops, WIFI and school programs"
  }
];

const howWeDeliverNutrition = [
  {
    image: icTechForKids,
    alt: "Tech for kids icon",
    title: "Tech for kids",
    content:
      "We support disadvantaged kids to get an equal education experience, making sure they can access laptops and WIFI."
  },
  {
    image: icRetoolingSchools,
    alt: "Retooling schools icon",
    title: "Retooling schools",
    content:
      "We equip schools and teachers with innovative learning methodologies (pedagogy) in the spirit of the Te Tiriti o Waitangi (Treaty of Waitangi)."
  }
];

const Manaiakalani = ({ localeData }) => {
  updateTitle("Manaiakalani");

  const explanation = [
    "Māori, Pasifika and disadvantaged learners face many unique challenges that have made education gaps difficult to close. These learners are less likely to leave the education system with a qualification, and more likely to leave school with a qualification below NCEA level.",
    "This project supports New Zealand learners and families who find it difficult to access or afford local, global and digital citizenship. It seeks to inspire Maori, Pasifika and low decile learners to lift their achievement through the application of a purposeful methodology based on community engagement, a digital pedagogy and enhanced teacher practice. Together let’s help close this gap."
  ];

  return (
    <Layout>
      <Banner image={bannerImage} bgColor="greyBackground">
        <div className={bannerContent}>
          <H2 marginBottom={16} marginBottomMobile={12}>
            Educational Equity for Māori, Pasifika and Disadvantaged Learners
          </H2>
          <P>
            Aotearoa New Zealand’s education gap is one of the largest in the
            world. So we support Māori, Pasifika and disadvantaged learners to
            get equal access to digital education.
          </P>
        </div>
      </Banner>

      <OurImpacts data={impactsObj} />

      <DescriptionBlock
        heading={
          <span>
            This education gap <i>must</i> be closed
          </span>
        }
        alt="Kids smiling whilst eating"
        image={manaiakalaniDesc}
        text={explanation}
      />

      <HowWeDeliver
        header="How we deliver our education program"
        data={howWeDeliverNutrition}
      />

      <HowToHelp
        localeData={localeData}
        text="We’re a unique charity, in that we don’t ask for donations (though you are welcome to offer). "
      />

      <ProjectDeliveryPartners>
        <P>
          We believe in impact with evidence, not just good intentions. That’s
          why we work with expert delivery partners, to make sure all our
          projects are making long-lasting, systemic change.
        </P>
        <Flag>
          <img src={partnerLogo} alt="Manaiakalani Education logo" />
          <P>
            Our scholarship program is delivered in partnership with
            Manaiakalani’s cluster of 12 schools who share the vision to lead
            future focused learning in connected communities.
          </P>
        </Flag>
        <Quote
          image={quoteImage}
          imageAlt="Picture of Pat Snedden."
          quote='"We’re de-mystifying education so that these learners can stand alongside others as equals in their communities and in wider society." '
          author="Pat Snedden, Executive Chair of the Manaiakalani Education Trust"
        />
      </ProjectDeliveryPartners>
    </Layout>
  );
};

export default CMSComponent(null, Manaiakalani);
